import { render, staticRenderFns } from "./CreateTeamForm.vue?vue&type=template&id=55f75e91&"
import script from "./CreateTeamForm.vue?vue&type=script&lang=ts&"
export * from "./CreateTeamForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateTeamForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports